import Image, { StaticImageData } from 'next/image';
import Link from 'next/link';
import React from 'react';

import AspectRatio from '@/components/common/AspectRatio';

type TTripGuideProps = {
  href: string;
  image: StaticImageData;
  title: string;
};

export const TripGuide = ({ href, image, title }: TTripGuideProps) => {
  return (
    <Link href={href}>
      <AspectRatio
        ratio="1:1"
        hasImageHover={true}
        className="bg-gray-200 shadow rounded-xl md:rounded-xl hover:shadow-lg">
        <Image src={image.src} alt={title} layout="fill" objectFit="cover" loading="lazy" />
      </AspectRatio>

      <div className="mt-4 font-medium text-gray-900 text-md">{title}</div>
    </Link>
  );
};
